  
import React from 'react';
import { useDispatch } from 'react-redux';
import { GetUserInfo } from '../modules/account';
import { logOut } from '../api';
import { confirmAlert } from 'react-confirm-alert';
import ConfirmModal from '../common/ConfirmModal';

const UserInfo = ({userInfo, history}) => {
  const dispatch = useDispatch();
  const onLogOut = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ConfirmModal
            title="로그아웃"
            content="로그아웃 하시겠습니까?"
            onClose={onClose}
            isCancel={true}
            onConfirm={()=>{
              logOut();
              history.push('/');
              dispatch(GetUserInfo());
              onClose();
            }}
          />
        )
      }
    })    
  }
  return (
    <dl>
      <dt>
        {userInfo.picture ?
          <img className="login_img" src={userInfo.picture} alt="google_picture"/>:
          <img src={require('../images/avator.png')} alt="avator"/>
        }
      </dt>
      <dd>
        <ul>
            <li>
              {userInfo ? <div className="name">{userInfo.name}</div>: ''}
              {userInfo ? <span> 회원님</span>: ''}
            </li>
            <li>{`${userInfo ? userInfo.email : ''}`}</li>
            <li  onClick={onLogOut}>
              <img src={require('../images/logout-btn.png')} alt="logout"/>
            </li>
        </ul>
      </dd>
    </dl>
  );
}

export default UserInfo;
